import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Box, debounce } from '@mui/material';
import {
  getMoreVehicle,
  getVehicle,
  patchUpdateVehicle,
  postAddVehicle,
} from 'redux/actions/UserVehicle';
import {
  getDriver,
  patchUpdateDriver,
  postAddDriver,
} from 'redux/actions/UserDriver';
import { getSubVendorRegion } from 'redux/actions/UserServiceCity';
import { getChooseYourService } from 'redux/actions/UserChooseYourService';
import { getOnBoardCompliance } from 'redux/actions/UserCompliance';
import { getCar } from 'redux/actions/UserCar';
import {
  getSubVendor,
  patchUpdateSubVendor,
} from 'redux/actions/UserSubVendor';
import useModal from 'hooks/useModal';
import CommonDialog from 'components/commonDialog/CommonDialog';
import CommonMultiImageForm from 'components/commonMultiImageForm/CommonMultiImageForm';
import ProfileCard from 'components/profileCard/ProfileCard';
import { vehicleDialogData } from 'pages/vehicle/VehiceData';
import SubVendorTablist from './SubVendorTablist';
import {
  editSubVendorDialogData,
  subVendorDriverDialogData,
} from './SubVendorData';
import { getDateFormat, handlePermissions } from 'utils/utils';
import SubBreadCrumb from './SubBreadCrumb';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { filterStatusData,filterStatusVehicle } from 'pages/vendor/VendorBreadCrumbData';
import { driverDialogData } from 'pages/drivers/DriverData';

const SubVendordetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { state } = location;

  const { open, toggle } = useModal();
  const { open: openSubVendorDriver, toggle: setSubVendorDriver } = useModal();
  const { open: openSubVendorVehicle, toggle: setSubVendorVehicle } =
    useModal();

  // ----FormatingDate---
  const handleDateFormating = (data) => {
    return getDateFormat(data);
  };

  const driverData = useSelector(
    (state) => state?.userDriver?.userDriver?.data
  );
  const vehicleData = useSelector(
    (state) => state?.userVehicle?.userVehicle?.data
  );
  const vehicleMoreData = useSelector(
    (state) => state?.userMoreVehicle?.userMoreVehicle?.data
  );
  const subVendorDetails = useSelector(
    (state) => state?.userSubVendor?.userSubVendor?.data?.body[0]
  );
  const subVendorMoreDetails = useSelector(
    (state) => state?.userDetailSubVendor?.userDetailSubVendor?.data
  );
  const subVendorMoreData = useSelector(
    (state) => state?.userMoreVehicle?.userMoreVehicle?.data
  );
  const subVendorService = useSelector(
    (state) => state?.userSubVendorRegion?.userSubVendorRegion?.data
  );
  const chooseYourServiceData = useSelector(
    (state) => state?.userChooseYourService?.userChooseYourService?.data
  );

  const loaderDriver = useSelector((state) => state?.userDriver?.loading);
  const loaderVehicle = useSelector((state) => state?.userVehicle?.loading);
  const loaderSubVendor = useSelector((state) => state?.userSubVendor?.loading);
  const loaderSubVendorMoreData = useSelector(
    (state) => state?.userMoreVehicle?.loading
  );
  const postAddVehicleSuccess = useSelector(
    (state) => state?.userAddVehicle?.userAddVehicle?.success
  );

  const carList = useSelector((state) => state?.userCar?.userCar?.data);

  const carOption = carList?.body?.map((val, idx) => {
    return { value: val?.id, label: val?.carType, seater: val?.seater };
  });

  const tabType = state?.tabType;
  const [selectedImage, setSelectedImage] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [defaultValue, setDefaultValue] = useState({});
  const [iconId, setIconId] = useState(null);
  const [value, setValue] = useState('drivers');
  const [status, setStatus] = useState('');
  const [filterLocation, setFilterLocation] = useState('');
  const [search, setSearch] = useState('');
  const [openModel, setOpenModel] = useState(false);
  const [showOtherComponent, setShowOtherComponent] = useState(false);
  const [formData, setFormData] = useState(subVendorDriverDialogData);
  const [type, setType] = useState('Driver');
  const [subButtonText, setSubButtonText] = useState('+ Driver');

  let filterDataVehicle = {
    id: state?.companyId,
    page: page,
    dateFrom: '',
    dateTo: '',
    status: status,
    location: filterLocation,
    pageSize: rowsPerPage,
    type: 'subVendor',
    search: search,
  };

  let filterDataDriver = {
    id: state?.companyId,
    page: page,
    dateFrom: '',
    dateTo: '',
    status: status,
    location: filterLocation,
    pageSize: rowsPerPage,
    type: 'subVendor',
    search: search,
  };

  const breadcrumbPaths = [
    { name: 'Sub-vendor', url: '/sub-vendor', className: 'colorGrey' },
    { name: state?.name, url: '/sub-vendor/details', className: 'colorGrey' },
  ];

  let filterData = {
    subVendorId: state?.subVendorId,
    status: '',
    page: '',
    pageSize: '',
    date: '',
  };

  const subVendorData = {
    submitterId: state?.companyId,
    submitterType: 'company',
  };
  const data = {
    id: state?.companyId,
    type: 'Company',
    businessType:'1'
  };

  useEffect(() => {
    dispatch(getSubVendor(filterData));
    dispatch(getDriver(filterDataDriver));
    dispatch(getCar());
  }, []);

  useEffect(() => {
    if (postAddVehicleSuccess) {
      setShowOtherComponent(true);
    } else {
      setShowOtherComponent(false);
    }
  }, [postAddVehicleSuccess]);

  const subVendorDefaultValue = {
    name: subVendorDetails?.vendorName,
    vendorName: subVendorDetails?.companyName,
  };

  // ---FOR DRIVER EDIT---
  const onDialog = (data) => {
    if (value === 'drivers') {
      const profileData = {
        driverId: data?.id,
        parentId: state?.companyId || subVendorDetails?.companyId,
        data: {
          firstName: data?.driverName,
          lastName: '',
          email: data?.email,
          countryCode: '+91',
          mobile: data?.number,
          companyName: '',
          location: data?.address,
          isB2B: 'true',
        },
      };
      dispatch(patchUpdateDriver(profileData));
      setOpenModel(false);
    }
  };

  // ---FOR SUBVENDOR EDIT---
  const onEditDialog = (data) => {
    const profileData = {
      subVendorId: subVendorDetails?.id,
      data: {
        firstName: data?.name,
        lastName: '',
        email: data?.email,
        countryCode: '+91',
        mobile: data?.number,
        companyName: data?.name,
        location: data?.address,
        isB2B: 'true',
      },
    };

    dispatch(patchUpdateSubVendor(profileData));
    toggle();
  };

  // <---- ADD SUBVENDOR DRIVER and SUBVENDOR VEHICLE ----->
  const onSubmit = (val) => {
    if (val?.driverName) {
      const driverData = {
        mobile: val.number,
        firstName: val.driverName,
        lastName: '',
        email: val.email,
        countryCode: '+91',
        parentId: state?.companyId || subVendorDetails?.companyId,
        vendorId: subVendorDetails?.companyId,
        companyName: 'abc12121qw' + val.number,
        isB2B: 'true',
      };
      dispatch(postAddDriver(driverData));
    } else {
      const data = {
        ...val,
        carType: 'COC',
        seating: parseInt(val?.seating),
        id: state?.companyId || subVendorDetails?.companyId,
        vendorId: subVendorDetails?.companyId,
        type: 'subVendor',
        avtar: selectedImage,
      };
      let formData = new FormData();

      Object.keys(data).map((val) => {
        formData.append(val, data[val]);
      });
      dispatch(postAddVehicle(formData));
    }
  };

  const onImageChange = (val) => {
    setSelectedImage(val);
  };

  // ---REDIRECTION FROM TABLE---
  const onClickSubvendorTable = (navigate, val) => {
    if (val?.authId) {
      navigate(`/sub-vendor/driver/details`, {
        state: {
          id: val.id,
          comapnyId: state?.companyId,
          subVendorId: state?.id,
          companyName: state?.name,
          cityLocation: state?.cityLocation,
          name: val.name,
          status: val?.status,
        },
      });
    } else {
      navigate(`/sub-vendor/vehicle/details`, {
        state: {
          id: val.id,
          comapnyId: state?.companyId,
          subVendorId: state?.id,
          companyName: state?.name,
          name: val.carModel,
        },
      });
    }
  };

  // --- ONTAB CHANGE---
  const handleTabChange = (val) => {
    setValue(val);
    setPage(0);
    setStatus([]);
    setSearch('')
    if (val === 'drivers') {
      setSubButtonText('+ Driver');
      setType('Driver');
      setFormData(subVendorDriverDialogData);
      dispatch(getDriver({...filterDataDriver,search:'',status: '',page:0}));
    } else if (val === 'vehicleDetails') {
      setSubButtonText('+ Vehicle');
      setType('Vehicle');
      setFormData(vehicleDialogData(carOption));
      dispatch(getVehicle({...filterDataVehicle,search:'',status: '',page:0}));
    } else if (val === 'moreDetails') {
      setSubButtonText('');
      dispatch(getMoreVehicle(subVendorData));
      dispatch(getSubVendorRegion(subVendorData));
      dispatch(getChooseYourService(data));
    }
  };

  // ---FILTER CHANGE---
  const onFilterChange = (val) => {
    setPage(0);
    const defaultStatus = [
      'Active',
      'InActive',
      'Blocked',
      'Pending',
      'Rejected',
    ];

    const filterLocations = val.filter((location) => {
      return !defaultStatus.includes(location);
    });

    const filterStatus = val.filter((status) => {
      return defaultStatus.includes(status);
    });

    setStatus(filterStatus);
    setFilterLocation(filterLocations);

    if (value === 'drivers') {
      const driverFilterData = {
        ...filterDataDriver,
        status: filterStatus?.toString(),
        location: filterLocations?.toString(),
        page: 0,
      };
      dispatch(getDriver(driverFilterData));
    } else if (value === 'vehicleDetails') {
      const vehicleFilterData = {
        ...filterDataVehicle,
        status: filterStatus?.toString(),
        location: filterLocations?.toString(),
        page: 0,
      };
      dispatch(getVehicle(vehicleFilterData));
    }
  };

  // ---RESET FILTER---
  const onRestFilter = () => {
    setStatus('');
    if (value === 'drivers') {
      const driverFilterData = {
        ...filterDataDriver,
        status: '',
      };
      dispatch(getDriver(driverFilterData));
    } else if (value === 'vehicleDetails') {
      const vehicleFilterData = {
        ...filterDataVehicle,
        status: '',
      };
      dispatch(getVehicle(vehicleFilterData));
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (value === 'drivers') {
      dispatch(getDriver({ ...filterDataDriver, page: newPage }));
    } else if (value === 'vehicleDetails') {
      dispatch(getVehicle({ ...filterDataVehicle, page: newPage }));
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    if (value === 'drivers') {
      dispatch(
        getDriver({
          ...filterDataDriver,
          page: 0,
          pageSize: parseInt(event.target.value),
        })
      );
    } else if (value === 'vehicleDetails') {
      dispatch(
        getVehicle({
          ...filterDataVehicle,
          page: 0,
          pageSize: parseInt(event.target.value),
        })
      );
    }
  };

  // ---OnSearch---
  const onSearch = debounce((e) => {
    setSearch(e);
    setPage(0);
    if (value === 'drivers') {
      const searchFilterData = {
        ...filterDataDriver,
        search: e,
        page: 0,
      };
      dispatch(getDriver(searchFilterData));
    } else if (value === 'vehicleDetails') {
      const searchFilterData = {
        ...filterDataVehicle,
        search: e,
        page: 0,
      };
      dispatch(getVehicle(searchFilterData));
    }
  }, 1000);

  // ---ON CLICK HEADER MORE ICON---
  const onClickStatusIcon = (data) => {
    setDefaultValue(value);
    setIconId(data.subVendorId);
    if (data === 'Deactivate') {
      const profileData = {
        subVendorId: state?.subVendorId,
        data: {
          status: 'InActive',
          isB2B: 'true',
        },
      };
      dispatch(patchUpdateSubVendor(profileData));
    } else if (data === 'Activate') {
      const profileData = {
        subVendorId: state?.subVendorId,
        data: {
          status: 'Active',
          isB2B: 'true',
        },
      };
      dispatch(patchUpdateSubVendor(profileData));
    } else if (data === 'Block') {
      const profileData = {
        subVendorId: state?.subVendorId,
        data: {
          status: 'Blocked',
          isB2B: 'true',
        },
      };
      dispatch(patchUpdateSubVendor(profileData));
    } else if (data === 'Unblock') {
      const profileData = {
        subVendorId: state?.subVendorId,
        data: {
          status: 'Active',
          isB2B: 'true',
        },
      };
      dispatch(patchUpdateSubVendor(profileData));
    }
  };

  // ---ON MORE ICON CLICK---
  const onClickMoreIcon = (data, iconType) => {
    if (value === 'drivers') {
      const value = {
        driverName: data?.name,
        email: data?.email,
        number: data?.mobile,
        address: data?.location,
        name: data?.vendorName,
        vendorName: data?.subVendorName,
        id: data?.id,
      };
      setDefaultValue(value);
      setIconId(data.id);
      if (iconType === 'Delete') {
      } else if (iconType === 'Edit') {
        setOpenModel(true);
      } 
      else if (iconType === 'Upload Compliance') {
  setOpenModel(true);
  setIconId(data.id);

  const profileData = {
    driverId: data.id,
    type: 'driverRegistration',
  };

  setShowOtherComponent(true);
  dispatch(getOnBoardCompliance(profileData));
}else if (iconType === 'Deactivate') {
        const profileData = {
          driverId: data.id,
          data: {
            status: 'InActive',
            isB2B: 'true',
          },
        };
        dispatch(
          patchUpdateDriver({ ...profileData, parentId: state?.companyId })
        );
      } else if (iconType === 'Activate') {
        const profileData = {
          driverId: data.id,
          data: {
            status: 'Active',
            isB2B: 'true',
          },
        };
        dispatch(
          patchUpdateDriver({ ...profileData, parentId: state?.companyId })
        );
      } else if (iconType === 'Block') {
        const profileData = {
          driverId: data.id,
          data: {
            status: 'Blocked',
            isB2B: 'true',
          },
        };
        dispatch(
          patchUpdateDriver({ ...profileData, parentId: state?.companyId })
        );
      } else if (iconType === 'Unblock') {
        const profileData = {
          subVendorId: data.id,
          driverId: data.id,
          data: {
            status: 'Active',
            isB2B: 'true',
          },
        };
        dispatch(
          patchUpdateDriver({ ...profileData, parentId: state?.companyId })
        );
      }
    } else if (value === 'vehicleDetails') {
      const value = data;
      setDefaultValue(value);
      setIconId(data.id);
      if (iconType === 'Delete') {
      } else if (iconType === 'Edit') {
        setOpenModel(true);
      } else if (iconType === 'Upload Compliance') {
        setOpenModel(true);
        setIconId(data?.id);
        const profileData = {
          vehicleId: data.id,
          type: 'vehicleRegistration',
        };
        setShowOtherComponent(true);
        dispatch(getOnBoardCompliance(profileData));
      } else if (iconType === 'Deactivate') {
        const profileData = {
          vehicleId: data.id,
          type: 'subVendor',
          data: {
            isApproved: 'InActive',
          },
        };
        dispatch(
          patchUpdateVehicle({ ...profileData, parentId: state?.companyId })
        );
      } else if (iconType === 'Activate') {
        const profileData = {
          vehicleId: data.id,
          type: 'subVendor',
          data: {
            isApproved: 'Active',
          },
        };
        dispatch(
          patchUpdateVehicle({ ...profileData, parentId: state?.companyId })
        );
      }
    }
  };

  const handleClose = () => {
    setOpenModel(false);
  };

  const handleVehicleCompliance = () => {
    setOpenModel(false);
    setShowOtherComponent(false);
  };

  const closeUploadCompliance = () => {
    setShowOtherComponent(false);
  };

  //Passing props
  const profileObj = {
    details: subVendorDetails,
    open: open,
    toggle: toggle,
    onDialog: onEditDialog,
    type: 'Sub-Vendor',
    editDialogData: editSubVendorDialogData,
    onClickStatusIcon: onClickStatusIcon,
  };

  //roles and permissions 
  const roleAndPermissions = useSelector((state) => state?.getRolesAndPermissions?.rolesAndPermissions);
  const subVendorRoleEnum = roleAndPermissionEnum.subvendor
  const cityManagerRoleEnum = roleAndPermissionEnum.citymanager

  const accessCityManagerForAdd = handlePermissions(roleAndPermissions, cityManagerRoleEnum.moduleKey, {defaultAllAccess: cityManagerRoleEnum.all, customAccess: cityManagerRoleEnum.add});

  const accessForAdd = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {defaultAllAccess: subVendorRoleEnum.all, customAccess: subVendorRoleEnum.add});
  const accessForOnlyView = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.subVendorView});
  const accessForOnlyEdit = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.subVendorEdit});
  const accessForOnlyActivate = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.subVendorActivate});

  const accessForOnlyBlock = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.subVendorBlock});

  const accessForOnlyAdd = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.subVendorAdd});

  const accessForSubVendorDriverEdit = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.editDriver});
  const accessForSubVendorDriverActivate = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.activateDriver});

  const accessForSubVendorVehicleBlock = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.blockVehicel});

  const accessForSubVendorVehicleEdit = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.editVehicle});

  const accessForSubVendorDriverBlock = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.blockDriver});

  const viewMoreIconDriver = (accessCityManagerForAdd || accessForAdd || accessForSubVendorDriverEdit || accessForSubVendorDriverActivate||accessForSubVendorDriverBlock )
  const addButton = (accessCityManagerForAdd || accessForAdd ||accessForOnlyAdd )

  const editButton = (accessCityManagerForAdd ||accessForAdd || accessForOnlyEdit)
  const statusChange = (accessCityManagerForAdd ||accessForOnlyActivate || accessForOnlyBlock )

  const viewMoreIconVehicle = (accessCityManagerForAdd || accessForAdd || accessForSubVendorVehicleEdit || accessForSubVendorVehicleBlock )
 console.log("driverDialogData", driverDialogData);
  return (
    <Box>
      <SubBreadCrumb
        subButtonText={addButton && subButtonText}
        formData={formData}
        type={type}
        name={state?.name}
        onSubmittBtn={onSubmit}
        defaultValues={subVendorDefaultValue}
        setSelectedImage={selectedImage}
        onImageChange={onImageChange}
        showOtherComponent={showOtherComponent}
        closeUploadCompliance={closeUploadCompliance}
        cityLocation={state?.cityLocation}
        tabType={tabType}
      />
      <ProfileCard profileObj={profileObj} loader={loaderSubVendor} editButton={editButton} statusChange={statusChange}/>
      <SubVendorTablist
        vehicledata={vehicleData}
        driverData={driverData}
        handleTabChange={handleTabChange}
        setSubVendorDriver={setSubVendorDriver}
        setSubVendorVehicle={setSubVendorVehicle}
        subVendorDetails={subVendorDetails}
        vehicleMoreData={vehicleMoreData}
        subVendorMoreDetails={subVendorMoreData}
        subVendorLocation={subVendorService}
        onClickSubvendorTable={onClickSubvendorTable}
        defaultStatus={status}
        onFilterChange={onFilterChange}
        onRestFilter={onRestFilter}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        page={page}
        rowsPerPage={rowsPerPage}
        chooseYourServiceData={chooseYourServiceData}
        loaderDriver={loaderDriver}
        loaderVehicle={loaderVehicle}
        loaderSubVendorMoreData={loaderSubVendorMoreData}
        onClickMoreIcon={onClickMoreIcon}
        onSearch={onSearch}
        search={search}
        viewMoreIconDriver={viewMoreIconDriver}
        viewMoreIconVehicle={viewMoreIconVehicle}
        filterdata={value === 'vehicleDetails' ? filterStatusVehicle : filterStatusData}
      />

      
{openModel && value === 'drivers' && !showOtherComponent ? (
  <CommonDialog
    open={openModel}
    handleClose={handleClose}
    formData={subVendorDriverDialogData}
    button={'dialogButton'}
    onSubmittBtn={onDialog}
    type={'Edit Driver'}
    selectType={'edit'}
    defaultValues={defaultValue}
  />
) : null}

{/* DRIVER COMPLIANCE */}
{openModel && value === 'drivers' && showOtherComponent ? (
  <CommonMultiImageForm
    open={openModel}
    handleClose={handleVehicleCompliance}
    formData={vehicleDialogData(carOption)}
    button={'dialogButton'}
    onSubmittBtn={onDialog}
    selectType={'edit'}
    type={'Upload Driver Compliance'}
    defaultValues={defaultValue}
    onImageChange={onImageChange}
    showOtherComponent={showOtherComponent}
    tabName="driver"
    driverId={iconId}
  />
) : null}
{/* VEHICLE COMPLIANCE */}
{openModel && value === 'vehicleDetails' ? (
  <CommonMultiImageForm
    open={openModel}
    handleClose={handleVehicleCompliance}
    formData={vehicleDialogData(carOption)}
    button={'dialogButton'}
    onSubmittBtn={onSubmit}
    selectType={'edit'}
    type={'Upload Vehicle Compliance'}
    onImageChange={onImageChange}
    tabName="vehicle"
    showOtherComponent={showOtherComponent}
    defaultValue={defaultValue}
    vehicleId={iconId}
  />
) : null}
    </Box>
  );
};

export default SubVendordetails;
